import Parse from 'html-react-parser';

function BMP20268(props) {
    let svgCode =
    `<svg width="1800" height="1140" viewBox="0 0 1800 1140" fill="none" xmlns="http://www.w3.org/2000/svg">
    <style type="text/css">
    .boxStyle rect {
        ${props.boxStyle}
    }
    ${props.fontFace}
    </style>
    <g class="boxStyle">
        <rect width="1800" height="1140" fill="${props.backgroundFill}"/>
        <rect x="1416" y="74" width="288" height="44" rx="7" fill="${props.paramFill}"/>
        <rect x="1720" y="70" width="54" height="48" rx="7" fill="${props.highlightColourB}"/>
        <path d="M1747 102L1754.79 89.25H1739.21L1747 102Z" fill="${props.fontColour}"/>
        <text fill="${props.fontColour}" font-family="${props.fontName}" font-size="16" font-weight="900" letter-spacing="0em"><tspan x="1419" y="147.969">CONTENT FILTERS</tspan></text>
        <rect x="1400" y="164" width="340" height="950" fill="${props.paramFill}"/>
        <rect x="52" y="44" width="1296" height="1070" fill="${props.paramFill}"/>
        <rect x="18" y="44" width="30" height="1070" fill="${props.paramFill}"/>
        <path d="M1451 103L1442.83 97.9853M1444.7 94.522C1444.7 98.6764 1441.41 102.044 1437.35 102.044C1433.29 102.044 1430 98.6764 1430 94.522C1430 90.3677 1433.29 87 1437.35 87C1441.41 87 1444.7 90.3677 1444.7 94.522Z" stroke="${props.fontColour}" stroke-width="5"/>
    </g>
    </svg>`

    props.svgReturn(78, svgCode, "bmp00268", 1800, 1140);

    const style = {
        display: props.display
    }

    return (
        <div style={style}>
            {Parse(svgCode)}
        </div>
    );
}

export default BMP20268;